import {ComponentData} from "../../engine/tools/EntityManager";

export class RotationMotor implements ComponentData {

    active: boolean = true
    speed: number = 2

    constructor(options?: Partial<RotationMotor>) {
        Object.assign(this, options)
    }
}